import { SignalWatcher, WithDisposable } from '@blocksuite/affine/global/lit';
import { ShadowlessElement } from '@blocksuite/affine/std';
import { EmailIcon } from '@blocksuite/icons/lit';
import { html } from 'lit';
import { property } from 'lit/decorators.js';

import type { MailMessageAttachment } from '../../utils/mail-selection-context';

export class ChatPanelMailChip extends SignalWatcher(
  WithDisposable(ShadowlessElement)
) {
  @property({ attribute: false })
  accessor mail!: MailMessageAttachment;

  @property({ attribute: false })
  accessor onRemove: ((mail: MailMessageAttachment) => void) | undefined;

  override render() {
    return html`<chat-panel-chip
      .state=${'finished'}
      .name=${this._getLabel()}
      .tooltip=${this._getTooltip()}
      .icon=${EmailIcon()}
      .closeable=${!!this.onRemove}
      .onChipDelete=${this._handleRemove}
    ></chat-panel-chip>`;
  }

  private _getLabel(): string {
    return this.mail.subject || this.mail.sender || 'Mail';
  }

  private _getTooltip(): string {
    const { sender, fromAddress, subject, dateLabel, snippet } = this.mail;
    return [
      `Mail: ${subject || '(ohne Betreff)'}`,
      `Von: ${fromAddress ? `${sender} <${fromAddress}>` : sender}`,
      dateLabel ? `Datum: ${dateLabel}` : null,
      snippet ? `Auszug: ${snippet}` : null,
    ]
      .filter((line): line is string => Boolean(line))
      .join('\n');
  }

  private readonly _handleRemove = () => {
    this.onRemove?.(this.mail);
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'chat-panel-mail-chip': ChatPanelMailChip;
  }
}
